/* --------------------------------------------------------------------------------------
   browser.component.js

   Copyright © 2019 Xerox Corporation. All Rights Reserved.
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const browserComponent = {
  template: require("./browser.html"),
  bindings: {
    searchEnabled: "<",
    node: "=",
    matter: "=?",
    selectionType: "@",
    selected: "=?",
  },
  controllerAs: "vm",
  controller: class BrowserCtrl {
    /* @ngInject */
    constructor(browserService, commonService, $state) {
      this.browserService = browserService;
      this.commonService = commonService;
      this.$state = $state;
    }

    async $onInit() {
      this.loading = true;
      this.navigationStack = [];
      this.node = await this.browserService.getNode(null, "Clients", "root");

      if (this.node.More) {
        this.showClientSearch = true;
        this.loading = false;
        this.commonService.updateView();
      } else {
        this.showClientSearch = false;
        this.node.Children.sort((a, b) => {
          const aConcat =
            a.EntryType === "Folder" ? "0" : "1" + a.DisplayName.toUpperCase();
          const bConcat =
            b.EntryType === "Folder" ? "0" : "1" + b.DisplayName.toUpperCase();

          if (aConcat > bConcat) {
            return 1;
          } else if (aConcat < bConcat) {
            return -1;
          } else {
            return 0;
          }
        });
        this.addAllowed = this.selectionType == "folder";
        this.loading = false;
        this.commonService.updateView();
      }
    }

    async switchNode() {
      this.showClientSearch = false;
      this.loading = true;

      try {
        this.oldNode = angular.copy(this.node);
        angular
          .element("#browser-back-button-1")
          .xrxbutton({ disabled: false });
        angular
          .element("#browser-back-button-2")
          .xrxbutton({ disabled: false });

        this.node = await this.browserService.getNode(
          this.getNextNodePath(this.selected.ID),
          this.selected.DisplayName,
          this.selected.EntryType
        );

        if (this.node.More) {
          this.showMatterSearch = true;
          this.loading = false;
          this.commonService.updateView();
          return;
        }

        this.node.Children.sort((a, b) => {
          const aConcat =
            a.EntryType === "Folder" ? "0" : "1" + a.DisplayName.toUpperCase();
          const bConcat =
            b.EntryType === "Folder" ? "0" : "1" + b.DisplayName.toUpperCase();

          if (aConcat > bConcat) {
            return 1;
          } else if (aConcat < bConcat) {
            return -1;
          } else {
            return 0;
          }
        });

        if (this.node.EntryType == "matter") {
          this.matter = this.node;
        }

        this.navigationStack.push(this.oldNode);
        angular
          .element("#search-button")
          .xrxbutton({ disabled: !this.hasDocuments(this.node) });
      } catch (e) {
        this.error = e;
      } finally {
        this.loading = false;
        this.commonService.updateView();
      }
    }

    hasDocuments(node) {
      return node.Children.some((item) => item.EntryType == "Document");
    }

    closeLoading() {
      if (this.error) {
        this.showerror = true;
      }
    }

    getNextNodePath(nextNodeID) {
      // TODO: Do this in a proper way please

      const result = [...this.navigationStack, this.node].map(
        (item) => item.ID
      );

      if (!result) {
        return "/" + nextNodeID;
      } else {
        if (result.length > 3) {
          result.length = 3;
        }
        return (
          result.reduce((prev, next) => prev + "/" + next) + "/" + nextNodeID
        );
      }
    }

    confirmSwitchBack() {
      if (this.selected.length > 0) {
        this.confirmSwitch = true;
      } else {
        this.switchBack();
      }
    }

    switchBack() {
      this.node = this.navigationStack.pop();

      if (this.node.EntryType == "root" && this.node.More) {
        this.showClientSearch = true;
        return;
      }

      if (this.node.EntryType == "client" && this.node.More) {
        this.showMatterSearch = true;
        return;
      }

      if (this.node.EntryType == "client") {
        this.matter = null;
      }

      if (this.node.EntryType == "root") {
        angular.element("#browser-back-button-1").xrxbutton({ disabled: true });
        angular.element("#browser-back-button-2").xrxbutton({ disabled: true });
      }
      angular
        .element("#search-button")
        .xrxbutton({ disabled: !this.hasDocuments(this.node) });
    }

    getBreadcrumb() {
      return [...this.navigationStack, this.node]
        .map((item) => item.DisplayName)
        .reduce((prev, next) => prev + " > " + next);
    }

    showSelectAllButton() {
      return (
        this.selectionType == "file" &&
        this.node.Children.some((node) => node.EntryType == "Document")
      );
    }

    getCurrentBoxClass() {
      const searchEnabledClass = this.showSelectAllButton()? 'with-search-and-select' : 'with-search' 
      return this.searchEnabled? searchEnabledClass : 'no-search'
    }

    selectAll() {
      const currentDocs = this.node.Children.filter(n => n.EntryType == "Document")
      if (this.selected.length == currentDocs.length) {
        this.selected = [];
      } else {
        this.selected = currentDocs
      }
    }

    onCloseClientSearchPopup() {
      this.showClientSearch = false;
      this.showMatterSearch = false;
      angular.element("#client-search-popup").xrxpopup("close");
      angular.element("#matter-search-popup").xrxpopup("close");
      this.$state.go("main");
      this.commonService.updateView();
    }

    onCloseMatterSearchPopup() {
      this.showMatterSearch = false;
      angular.element("#matter-search-popup").xrxpopup("close");
      this.showClientSearch = this.node.More
      this.commonService.updateView();
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/browser/components/browser.component.js